import type {CreateMaterialFunctionFormPayload} from "./create-material-function.schema";

import {createMaterialFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialFunctionKeys, materialFunctionMutationKeys} from "../../../materialFunction-keys";

export function createMaterialFunctionMutationOptions() {
  return mutationOptions({
    mutationFn: (payload: CreateMaterialFunctionFormPayload) => createMaterialFunction(payload),
    mutationKey: materialFunctionMutationKeys.createMaterialFunction,
    onSuccess: async (_materialFunctionId, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: materialFunctionKeys.lists()});
    },
  });
}
